module.exports = __webpack_public_path__ + "img/hardware3.55857b86.png";